import AddBank from './add-bank';

export default AddBank;
export {default as AddBankNew} from './add-bank-new';
export {default as AddBankCompare} from './add-bank-compare';
